import { useEffect, useState, useRef, useContext, createContext, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./IndEvent.module.css"
import guestii_gif from '../../assets/images/guestii_gif.gif'
import { MovingTagContainer, MovingTypeContainer, MovingTextCostContainer, MovingPromoterContainer } from '../Utils/Helpers'


export const GuestiiTags = ({ handleClose, settingTags, toggledMenu=false, bulkEdit=false, setGuestiisChecked=null, guestiisChecked=null, setMainReloadKey=null }) => {
  const param = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [tagData, setTagData] = useState({ tags: [] });

  useEffect(() => {
    if (!toggledMenu) {
      const checkForTags = bulkEdit ? [...settingTags].map(g => ({ tags: g.tags.map(t => t.tag) })) : guestiisChecked.filter(g => settingTags.includes(g.guestii) && g.tags && g.tags.length > 0)

      if (checkForTags.length > 0) {
        let allSame = true;
        let currentCheck;

        checkForTags.map(t => t.tags).forEach((tagArr, i) => {
          if (i === 0) {
            currentCheck = JSON.stringify(tagArr);
            return;
          } else {
            if (JSON.stringify(tagArr) !== currentCheck) {
              allSame = false;
              return;
            } else {
              currentCheck = JSON.stringify(tagArr);
            }
          }
        })

        if (allSame) {
          const matchingTags = bulkEdit ? checkForTags[0].tags.map(t => ({ label: t, value: t })) : guestiisChecked.filter(g => settingTags.includes(g.guestii) && g.tags && g.tags.length > 0)[0].tags
          setTagData({ tags: matchingTags })
        } else {
          window.alert("The tags set for the selected Guestiis are currently NOT the same. If you edit and save, it will override all of the current tags.")
        }
      }
    } else {
      setTagData({ tags: toggledMenu.tags ? toggledMenu.tags.map(t => ({ label: t.tag, value: t.tag })) : [] })
    }
  }, [])

  const handleForm = async (control, label, input) => {
    switch (control) {
      case 'set':
        setTagData({tags: input.map(t => ({ value: t.value, label: t.value }))})
        break;
      case 'submit':
        if (toggledMenu || bulkEdit) {
          setIsLoading(true)

          const userId = localStorage.getItem("_id")
          const expiry = localStorage.getItem("expiry")
          if (!userId || !expiry) {
            localStorage.removeItem("_id")
            localStorage.removeItem("expiry")
            window.location = "/connect"
          }

          try {
            const body = {
              tags: tagData.tags,
              guestiis: bulkEdit ? settingTags.map(g => g.guestii._id) : [toggledMenu.guestii._id]
            }

            const res = await axios.post(`/api/events/update-guestii-tags/${param.event_id}`, body, {
              headers: {
                'x-user-id': userId,
                'x-expiry': expiry
              }
            });

            handleClose()
          } catch (err) {
            localStorage.removeItem("_id")
            localStorage.removeItem("expiry")
            window.location = "/connect"
          }

          setIsLoading(false)
        } else {
          setGuestiisChecked((prev) => {
            prev.forEach((g) => {
              settingTags.includes(g.guestii) ? g['tags'] = tagData.tags : []
            })

            return prev;
          })

          handleClose()
        }

        break;
    }
  }

  return (
    <div className={`${styles.popup_container_ind_team}`}>
      {!isLoading
        ?
          <div className={styles.ratings_layout}>
            <button className={styles.ind_close_ind} onClick={() => handleClose(true)}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

            <div className={styles.new_banner}>
              <div className={styles.new_title}>
                <p className={styles.bold}>Set Guestii Tags</p>
                <p className={styles.s1}>Select tags or create your own</p>
              </div>

              <div className={styles.banner_progress}>
                <div className={`${styles.progress_circle} ${styles.progress_circle_active}`}>
                  <i className={`fa-solid fa-star ${styles.m1}`}></i>
                </div>
              </div>
            </div>

            <div className={styles.ratings_form_container}>
              <div className={styles.tags_warning}>
                <p className={styles.s1}>Tags are event specific. Guestiis page shows all tags.</p>
              </div>

              <div className={styles.tagContainerOuter}>
                <MovingTagContainer
                  label={"Tags"}
                  icon={"fa-solid fa-tag"}
                  handleForm={handleForm}
                  formData={tagData}
                  showLabel={false}
                  bottom={false}
                  border={true}
                />
              </div>
            </div>

            <div className={styles.control_container}>
              <button onClick={() => handleForm('submit')} className={`${styles.control_btn} ${styles.next_btn}`}>
                <i className={`fa-solid fa-check ${styles.m1}`}></i>
              </button>
            </div>
          </div>
        :
          <div className={styles.loading_layout}>
            <img src={guestii_gif}/>
          </div>
      }
    </div>
  )
}

export const GuestiiTypes = ({ handleClose, settingTypes, bulkEdit=false, toggledMenu=false, setGuestiisChecked=null, guestiisChecked=null }) => {
  const param = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [typeData, setTypeData] = useState({ type: {}});

  useEffect(() => {
    if (!toggledMenu) {
      const checkForTypes = bulkEdit ? [...settingTypes].map(g => ({ type: g.ticket?.type || "FREE" })) : guestiisChecked.filter(g => settingTypes.includes(g.guestii) && g.type)

      if (checkForTypes.length > 0) {
        let allSame = true;
        let currentCheck;

        checkForTypes.map(t => t.type).forEach((type, i) => {
          if (i === 0) {
            currentCheck = JSON.stringify(type);
            return;
          } else {
            if (JSON.stringify(type) !== currentCheck) {
              allSame = false;
              return;
            } else {
              currentCheck = JSON.stringify(type);
            }
          }
        })

        if (allSame) {
          const matchingType = bulkEdit ? checkForTypes[0].type : guestiisChecked.filter(g => settingTypes.includes(g.guestii) && g.type)[0].type
          setTypeData({ type: { label: matchingType, value: matchingType } })
        } else {
          window.alert("The types set for the selected Guestiis are currently NOT the same. If you edit and save, it will override all of the current types.")
        }
      }
    } else {
      setTypeData({ type: { label: toggledMenu.ticket?.type || "FREE", value: toggledMenu.ticket?.type || "FREE" } })
    }
  }, [])

  const handleForm = async (control, label, input) => {
    switch (control) {
      case 'set':
        setTypeData({ type: input })
        break;
      case 'submit':
        if (toggledMenu || bulkEdit) {
          setIsLoading(true)

          const userId = localStorage.getItem("_id")
          const expiry = localStorage.getItem("expiry")
          if (!userId || !expiry) {
            localStorage.removeItem("_id")
            localStorage.removeItem("expiry")
            window.location = "/connect"
          }

          try {
            const body = {
              type: typeData.type.value,
              guestiis: bulkEdit ? settingTypes.map(g => g.guestii._id) : [toggledMenu.guestii._id]
            }

            const res = await axios.post(`/api/events/update-guestii-ticket-type/${param.event_id}`, body, {
              headers: {
                'x-user-id': userId,
                'x-expiry': expiry
              }
            });

            handleClose()
          } catch (err) {
            localStorage.removeItem("_id")
            localStorage.removeItem("expiry")
            window.location = "/connect"
          }

          setIsLoading(false)
        } else {
          setGuestiisChecked((prev) => {
            prev.forEach((g) => {
              settingTypes.includes(g.guestii) ? g['type'] = typeData.type.value : []
            })

            return prev;
          })
          
          handleClose()
        }

        break;
    }
  }

  return (
    <div className={`${styles.popup_container_ind_team}`}>
      {!isLoading
        ?
          <div className={styles.ratings_layout}>
            <button className={styles.ind_close_ind} onClick={() => handleClose(true)}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

            <div className={styles.new_banner}>
              <div className={styles.new_title}>
                <p className={styles.bold}>Set Ticket Types</p>
                <p className={styles.s1}>Select free/paid entry and cost</p>
              </div>

              <div className={styles.banner_progress}>
                <div className={`${styles.progress_circle} ${styles.progress_circle_active}`}>
                  <i className={`fa-solid fa-ticket ${styles.m1}`}></i>
                </div>
              </div>
            </div>

            <div className={styles.ratings_form_container}>
              <div className={styles.tags_warning}>
                <p className={styles.s1}>Ticket types are event specific. Guestiis page shows all types.</p>
              </div>

              <div className={styles.tagContainerOuter}>
                <MovingTypeContainer
                  label={"Type"}
                  icon={"fa-solid fa-tag"}
                  handleForm={handleForm}
                  formData={typeData}
                  showLabel={false}
                  bottom={false}
                  border={true}
                />
              </div>
            </div>

            <div className={styles.control_container}>
              <button onClick={() => handleForm('submit')} className={`${styles.control_btn} ${styles.next_btn}`}>
                <i className={`fa-solid fa-check ${styles.m1}`}></i>
              </button>
            </div>
          </div>
        :
          <div className={styles.loading_layout}>
            <img src={guestii_gif}/>
          </div>
      }
    </div>
  )
}

export const GuestiiPlusOnes = ({ handleClose, settingPlusOnes, toggledMenu=false, bulkEdit=false, setGuestiisChecked=null, guestiisChecked=null, setMainReloadKey=null }) => {
  const param = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [plusOneData, setPlusOneData] = useState({});
  const intervalRef = useRef(null);
  const pressTimerRef = useRef(null);


  useEffect(() => {
    if (!toggledMenu) {
      const checkForPlusOnes = bulkEdit ? Object.fromEntries([...settingPlusOnes].map(({ guestii, plus_ones = 0 }) => [ guestii._id, plus_ones ])) : Object.fromEntries([...guestiisChecked].map(({ guestii, plus_ones = 0 }) => [ guestii, plus_ones ]));
      setPlusOneData(checkForPlusOnes)
    } else {
      setPlusOneData({ [toggledMenu['guestii']['_id']]: toggledMenu.plus_ones || 0 })
    }
  }, [])

  const handleForm = async (control, label, input) => {
    switch (control) {
      case 'submit':
        if (toggledMenu || bulkEdit) {
          setIsLoading(true)

          const userId = localStorage.getItem("_id")
          const expiry = localStorage.getItem("expiry")
          if (!userId || !expiry) {
            localStorage.removeItem("_id")
            localStorage.removeItem("expiry")
            window.location = "/connect"
          }

          try {
            const body = {
              plus_ones: plusOneData,
              guestiis: bulkEdit ? settingPlusOnes.map(g => g.guestii._id.toString()) : [toggledMenu.guestii._id.toString()]
            }

            const res = await axios.post(`/api/events/update-guestii-plus-ones/${param.event_id}`, body, {
              headers: {
                'x-user-id': userId,
                'x-expiry': expiry
              }
            });

            handleClose()
          } catch (err) {
            localStorage.removeItem("_id")
            localStorage.removeItem("expiry")
            window.location = "/connect"
          }

          setIsLoading(false)
        } else {
          setGuestiisChecked((prev) => {
            prev.forEach((g) => {
              settingPlusOnes.includes(g.guestii) ? g['plus_ones'] = plusOneData[g['guestii']] || 0 : 0
            })

            return prev;
          })

          handleClose()
        }

        break;
    }
  }

  const increment = useCallback((id) => {
    setPlusOneData((prev) => ({
      ...prev,
      [id]: (prev[id] || 0) + 1
    }));
  }, []);

  const decrement = useCallback((id) => {
    setPlusOneData(prev => {
      const current = prev[id] || 0;
      if (current === 0) return prev;
      return {
        ...prev,
        [id]: current - 1
      };
    });
  }, []);

  const onPressStart = (id, plus = true) => {
    pressTimerRef.current = window.setTimeout(() => {
      plus ? increment(id) : decrement(id);
      intervalRef.current = window.setInterval(
        () => (plus ? increment(id) : decrement(id)),
        100
      );
    }, 500);
  };

  const onPressEnd = (id, plus = true) => {
    if (pressTimerRef.current) {
      clearTimeout(pressTimerRef.current);
      pressTimerRef.current = null;
      plus ? increment(id) : decrement(id);
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => () => {
    clearTimeout(pressTimerRef.current);
    clearInterval(intervalRef.current);
  }, []);


  return (
    <div className={`${styles.popup_container_ind_team}`}>
      {!isLoading
        ?
          <div className={styles.ratings_layout}>
            <button className={styles.ind_close_ind} onClick={() => handleClose(true)}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

            <div className={styles.new_banner}>
              <div className={styles.new_title}>
                <p className={styles.bold}>Set Guestii Plus Ones</p>
                <p className={styles.s1}>Choose the amount of plus ones for guestiis</p>
              </div>

              <div className={styles.banner_progress}>
                <div className={`${styles.progress_circle} ${styles.progress_circle_active}`}>
                  <i className={`fa-solid fa-star ${styles.m1}`}></i>
                </div>
              </div>
            </div>

            <div className={styles.limits_form_container}>
              <div className={styles.tags_warning}>
                <p className={styles.s1}>Plus ones are event specific. Guestiis page shows all plus ones.</p>
              </div>

              <div
                style={{
                  height: '100%',
                  maxHeight: '100%',
                  overflowY: 'scroll',
                  position : 'relative',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <div className={`${styles.table_container_indguestii} table_container`} style={{ gridTemplateColumns: '1fr', gridTemplateRows: `max-content` }}>
                  {settingPlusOnes.map((g, n) => {
                    const lastItem = n === (settingPlusOnes.length - 1);
                    const name = (toggledMenu || bulkEdit) ? `${g.guestii.first_name} ${g.guestii.last_name}` : g
                    const guestii_id = (toggledMenu || bulkEdit) ? g.guestii._id.toString() : g
                    // const phone = toggledMenu ? g.guestii.phone : g

                    return (
                      <div className={`${styles.guestii_invited_ind_max} ${styles.no_hover}`}>
                        <div className={styles.guestii_inner_split}>
                          <div className={styles.guestii_profile_rounded}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

                          <div className={styles.guestii_profile_info}>
                            <p className={styles.s1}>{name}</p>
                            {/* <p className={styles.xs2}>{phone}</p> */}
                          </div>
                        </div>

                        <div className={`${styles.widget_action_container_in} ${styles.numberInput}`}>
                          <label className={styles.xs3}>
                              Plus Ones:
                          </label>

                          <div className={styles.customNumberInput}>
                            <button
                              className={`${styles.numberControl}`}
                              onMouseDown={() => onPressStart(guestii_id, false)}
                              onMouseUp={() => onPressEnd(guestii_id, false)}
                              onMouseLeave={() => onPressEnd(guestii_id, false)}
                              onTouchStart={() => onPressStart(guestii_id, false)}
                              onTouchEnd={() => onPressEnd(guestii_id, false)}
                            >
                              <i className={`fa-solid fa-minus ${styles.xs2}`}></i>
                            </button>

                            <input
                              type="number"
                              disabled={true}
                              value={plusOneData[guestii_id] || 0}
                              className={styles.s1}
                            />

                            <button
                              className={`${styles.numberControl}`}
                              onMouseDown={() => onPressStart(guestii_id, true)}
                              onMouseUp={() => onPressEnd(guestii_id, true)}
                              onMouseLeave={() => onPressEnd(guestii_id, true)}
                              onTouchStart={() => onPressStart(guestii_id, true)}
                              onTouchEnd={() => onPressEnd(guestii_id, true)}
                            >
                              <i className={`fa-solid fa-plus ${styles.xs2}`}></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>

                <div className={`${styles.control_container} ${styles.control_last_item}`}>
                  <button onClick={() => handleForm('submit')} className={`${styles.control_btn} ${styles.next_btn}`}>
                    <i className={`fa-solid fa-check ${styles.m1}`}></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        :
          <div className={styles.loading_layout}>
            <img src={guestii_gif}/>
          </div>
      }
    </div>
  )
}

export const GuestiiPromoters = ({ handleClose, settingPromoters, bulkEdit=false, toggledMenu=false, setGuestiisChecked=null, guestiisChecked=null }) => {
  const param = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [promoterData, setPromoterData] = useState({ promoter: {}});
  const [searchableTeamMembers, setSearchableTeamMembers] = useState([])


  useEffect(() => {
    const handleTeamMembers = async () => {
      let availableMembers = []
      setIsLoading(true)

      const userId = localStorage.getItem("_id")
      const expiry = localStorage.getItem("expiry")
      if (!userId || !expiry) {
        locationStorage.removeItem("_id")
        locationStorage.removeItem("expiry")
        window.location = "/connect"
      }

      try {
        const retrieve = await axios.get(`/api/team/get-team-members/${userId}/${expiry}/${true}`);
        availableMembers = retrieve.data.teamMembers.filter(t => t.role.name === "Promoter").map(item => { return { label: `${item.first_name} ${item.last_name}`, value: item._id.toString() } })

        setSearchableTeamMembers(availableMembers)
      } catch (e) {
        localStorage.removeItem("_id")
        localStorage.removeItem("expiry")
        window.location = "/connect"
      }

      setIsLoading(false)


      if (!toggledMenu) {
        const checkForPromoters = bulkEdit ? [...settingPromoters].map(g => ({ promoter: `${g.source.first_name} ${g.source.last_name}` })) : guestiisChecked.filter(g => settingPromoters.includes(g.guestii))

        if (checkForPromoters.length > 0) {
          let allSame = true;
          let currentCheck;

          checkForPromoters.map(g => g.promoter_override).forEach((promoter, i) => {
            if (i === 0) {
              currentCheck = JSON.stringify(promoter);
              return;
            } else {
              if (JSON.stringify(promoter) !== currentCheck) {
                allSame = false;
                return;
              } else {
                currentCheck = JSON.stringify(promoter);
              }
            }
          })

          if (allSame) {
            // here
            const matchingType = bulkEdit ? checkForPromoters[0].promoter : guestiisChecked.filter(g => settingPromoters.includes(g.guestii) && g.promoter_override)[0].promoter_override
            const matchingPromoter = availableMembers.find(a => a.value === matchingType)
            setPromoterData({ promoter: matchingPromoter })
          } else {
            window.alert("The promoters set for the selected Guestiis are currently NOT the same. If you edit and save, it will override all of the current promoters.")
          }
        }
      } else {
        if (toggledMenu.source.role?.name === "Promoter") {
          setPromoterData({ promoter: { label: `${toggledMenu.source.first_name} ${toggledMenu.source.last_name}`, value: toggledMenu.source._id.toString() } })
        }
      }
    }

    handleTeamMembers()
  }, [])

  const handleForm = async (control, label, input) => {
    switch (control) {
      case 'set':
        setPromoterData({ promoter: input })
        break;
      case 'submit':
        if (toggledMenu || bulkEdit) {
          setIsLoading(true)

          const userId = localStorage.getItem("_id")
          const expiry = localStorage.getItem("expiry")
          if (!userId || !expiry) {
            localStorage.removeItem("_id")
            localStorage.removeItem("expiry")
            window.location = "/connect"
          }

          try {
            const body = {
              promoter: promoterData.promoter.value,
              guestiis: bulkEdit ? settingTypes.map(g => g.guestii._id) : [toggledMenu.guestii._id]
            }

            const res = await axios.post(`/api/events/update-guestii-source/${param.event_id}`, body, {
              headers: {
                'x-user-id': userId,
                'x-expiry': expiry
              }
            });

            handleClose()
          } catch (err) {
            localStorage.removeItem("_id")
            localStorage.removeItem("expiry")
            window.location = "/connect"
          }

          setIsLoading(false)
        } else {
          setGuestiisChecked((prev) => {
            prev.forEach((g) => {
              settingPromoters.includes(g.guestii) ? g['promoter_override'] = promoterData.promoter.value : []
            })

            return prev;
          })
          
          handleClose()
        }

        break;
    }
  }

  return (
    <div className={`${styles.popup_container_ind_team}`}>
      {!isLoading
        ?
          <div className={styles.ratings_layout}>
            <button className={styles.ind_close_ind} onClick={() => handleClose(true)}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

            <div className={styles.new_banner}>
              <div className={styles.new_title}>
                <p className={styles.bold}>Set Promoter</p>
                <p className={styles.s1}>Select the promoter for this Guestii</p>
              </div>

              <div className={styles.banner_progress}>
                <div className={`${styles.progress_circle} ${styles.progress_circle_active}`}>
                  <i className={`fa-solid fa-envelope ${styles.m1}`}></i>
                </div>
              </div>
            </div>

            <div className={styles.ratings_form_container}>
              <div className={styles.tags_warning}>
                <p className={styles.s1}>Promoter invites are event specific. Team page shows all promoters.</p>
              </div>

              <div className={styles.tagContainerOuter}>
                <MovingPromoterContainer
                  label={"Promoter"}
                  icon={"fa-solid fa-evelope"}
                  handleForm={handleForm}
                  formData={promoterData}
                  promoters={searchableTeamMembers}
                  showLabel={false}
                  bottom={false}
                  border={true}
                />
              </div>
            </div>

            <div className={styles.control_container}>
              <button onClick={() => handleForm('submit')} className={`${styles.control_btn} ${styles.next_btn}`}>
                <i className={`fa-solid fa-check ${styles.m1}`}></i>
              </button>
            </div>
          </div>
        :
          <div className={styles.loading_layout}>
            <img src={guestii_gif}/>
          </div>
      }
    </div>
  )
}

export const GuestiiRating = ({ handleClose, toggledMenu }) => {
  const param = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [rating, setRating] = useState(null);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    setRating(toggledMenu.rating)
  }, [])

  const handleForm = async (control, selection) => {
    switch (control) {
      case 'set':
        setRating(selection)
        break;
      case 'submit':
        setIsLoading(true)

        const userId = localStorage.getItem("_id")
        const expiry = localStorage.getItem("expiry")
        if (!userId || !expiry) {
          localStorage.removeItem("_id")
          localStorage.removeItem("expiry")
          window.location = "/connect"
        }

        try {
          const body = {
            rating: rating,
            guestii: toggledMenu.guestii._id
          }

          const res = await axios.post(`/api/events/rate-guestii/${param.event_id}`, body, {
            headers: {
              'x-user-id': userId,
              'x-expiry': expiry
            }
          });

          handleClose()
        } catch (err) {
          localStorage.removeItem("_id")
          localStorage.removeItem("expiry")
          window.location = "/connect"
        }

        setIsLoading(false)
        break;
    }
  }

  return (
    <div className={`${styles.popup_container_ind_team}`}>
      {!isLoading
        ?
          <div className={styles.ratings_layout}>
            <button className={styles.ind_close_ind} onClick={() => handleClose(true)}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

            <div className={styles.new_banner}>
              <div className={styles.new_title}>
                <p className={styles.bold}>Set Guestii Rating</p>
                <p className={styles.s1}>Choose a rating between 1-5 for this Guestii</p>
              </div>

              <div className={styles.banner_progress}>
                <div className={`${styles.progress_circle} ${styles.progress_circle_active}`}>
                  <i className={`fa-solid fa-ticket ${styles.m1}`}></i>
                </div>
              </div>
            </div>

            <div className={styles.ratings_form_container}>
              <div className={styles.tags_warning} style={{ margin: '1.5rem 0 0 0' }}>
                <p className={styles.s1}>Ratings are event specific. Guestiis page shows all ratings.</p>
              </div>

              <div className={styles.reviewContainer} onMouseLeave={() => setHovered(null)} >
                {Array.from({ length: 5 }).map((s, i) => {
                  const isFilled = hovered !== null && i+1 <= hovered
                  const isRated = rating !== null && i+1 <= rating
                  
                  return (
                    <button
                      id={i}
                      className={styles.starContainer}
                      onMouseEnter={() => setHovered(i+1)}
                      onClick={() => setRating(i+1)}
                    >
                      <i className={`fa-${isRated ? 'solid' : isFilled ? 'solid' : 'regular'} fa-star`} style={{ fontSize: '45px' }}></i>
                    </button>
                  )
                })}
              </div>
            </div>

            <div className={styles.control_container}>
              <button onClick={() => handleForm('submit')} className={`${styles.control_btn} ${styles.next_btn}`}>
                <i className={`fa-solid fa-check ${styles.m1}`}></i>
              </button>
            </div>
          </div>
        :
          <div className={styles.loading_layout}>
              <img src={guestii_gif}/>
          </div>
      }
    </div>
  )
}